import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import { titleCase } from '../../../../utils/views/pages/Dynamics'
import Select from 'react-select'

const PlanInformation = (props) => {
    const plan = props.plan
    const formDisabled = props.formDisabled
    const setPlan = props.setPlan    
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations    

    let validateField = (e) => {        
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        plan[e.target.name] = e.target.value
        setPlan(plan)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Plan information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Name
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={plan?.name}
                                id="input-name"
                                name="name"
                                placeholder="Plan Name"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>

                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-price"
                            >
                                Price
                            </label>

                            <InputGroup id="input-group" className="input-group-alternative ">

                                <InputGroupAddon addonType="prepend" className=''>
                                    <InputGroupText >
                                        <i className="fas fa-dollar-sign trailing"></i>
                                    </InputGroupText>

                                    <Input
                                        className="form-control-alternative"
                                        id="input-price"
                                        defaultValue={plan?.price}
                                        type="number"
                                        step="0.01"
                                        disabled={formDisabled}
                                        placeholder="Plan Price"
                                        name="price"
                                        onChange={handleInput}
                                        required={true}
                                        onBlur={validateField}
                                    />
                                </InputGroupAddon>

                            </InputGroup>

                        </FormGroup>
                    </Col>
                </Row>
                <Row>

                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-licenses"
                            >
                                Licenses
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-licenses"
                                defaultValue={plan?.licensesLimit}
                                type="number"
                                name="licensesLimit"
                                placeholder="Plan Licenses Limit"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>

                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-periodicity"
                            >
                                Periodicity (Months)
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-periodicity"
                                defaultValue={plan?.periodicity}
                                type="number"
                                name="periodicity"
                                placeholder="Plan periodicity in Months"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                    
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default PlanInformation;